
import {Tabs, Divider, Space, Card, Switch, Row, Col, Typography} from "antd";
import React, {useMemo, useState} from "react";
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import PlotlyStockChart from "../../../charts/Plotly/PlotlyStockChart";
import {sampleModernColors} from "../../../utils/colors";
import usePdfExport from "../../../hooks/usePdfExport";
import BlotterSnapshot from "./BlotterSnapshot";
import XrayPortfolios from "../../Xray/XrayPortfolios";
import Chip from "../../../components/Chips/Chip";
import useColors from "../../../hooks/useColors";
import { combineTextAndData, parseDelimitedResponse } from "./blotterUtils";

const CHART_COLORS = [
    '#0ea5e9',
    '#334155'
]


const BlotterResponse = ({response, data, closeResponse, extraDetails, timeSeriesData })=>{
    const [disableChart, setDisableChart] = useState(false);
    const [activeTab, setActiveTab] = useState('1');

    const onTabChange = (key) => {
        if (key === '0') {
            closeResponse?.();
        }
    }
    const textParts = parseDelimitedResponse(response.data);
    const { componentRef } = usePdfExport();

    const mergedData = combineTextAndData(textParts, data);
    const uniqueTickers = useMemo(() => {
        const tickersSet = new Set();
        mergedData.forEach(x => {
            const snapshot = x.snapshot;
            Object.keys(snapshot).forEach((ticker) => {
                tickersSet.add(ticker);
            });
        });
        return Array.from(tickersSet);
    }, [mergedData]);
    const colors = useColors({numberOfShades: uniqueTickers.length})

    const snapshotData = [...data].map((x, index)=>({
        key: x[0],
        name: x[0],
        ptfl: x[2],
        extra: extraDetails.length > 0 && <Chip label={"Beta"} value={`${(extraDetails[index]?.beta*100).toFixed(2)}%`} />
    }))

    // Step 2: Assign colors to each unique ticker
    const colorMap = useMemo(() => {
        // const colors = sampleModernColors(uniqueTickers.length);
        let mapping = {};
        uniqueTickers.forEach((ticker, i) => {
            mapping[ticker] = colors[i];
        });
        return mapping;
    }, [uniqueTickers]);
    const selectedDates = mergedData && mergedData.map(x=>x.timestamp);

    return (

        <Tabs defaultActiveKey="1" tabPosition={'left'} onChange={onTabChange} onTabClick={setActiveTab}>
            <Tabs.TabPane key={'0'} tab={'Back to Chart'} />
            <Tabs.TabPane key={'1'} tab={'Talking Points'}>
                <div className={'w-5/6 mx-auto'}>
                    {!disableChart && (
                        <div style={{height: 300, width: '100%'}}>
                            <PlotlyStockChart
                                timeseriesData={[...[...timeSeriesData].map((x, index) => ({
                                    ...x,
                                    area: false,
                                    color: CHART_COLORS[index % CHART_COLORS.length],
                                    areaOpacity: 0.15,

                                }))]}
                                disableAnnotations={false}
                                disableScrollbar={true}
                                verticalLines={selectedDates}
                                disableToolbar={true}
                                disableGrid={true}
                            />
                        </div>
                    )}
                    <Divider/>
                    <div ref={componentRef}> {/* Wrap snapshot content with ref */}
                        <Space direction={'vertical'} style={{width:'95%', maxHeight:'70vh'}} className={'overflow-y-auto hide-scrollbar'}>
                            {mergedData.map((row, index) => (
                                <div className={'pb-6'}>
                                    <BlotterSnapshot
                                        data={row}
                                        colorMap={colorMap}
                                        startDate={index > 0 ? mergedData[index - 1]?.timestamp : null}

                                    />
                                </div>
                            ))}
                        </Space>
                    </div>
                </div>
            </Tabs.TabPane>
            <Tabs.TabPane key={'3'} tab={'X-RAY'}>
                {activeTab === '3' && (
                    <XrayPortfolios portfolios={snapshotData}  />

                )}
            </Tabs.TabPane>

        </Tabs>

    )
}

export default BlotterResponse;
